import { useEffect } from 'react'

// TODO: inline
export function useWindowEvent<K extends string>(
  type: K,
  listener: K extends keyof WindowEventMap
    ? (this: Window, ev: WindowEventMap[K]) => void
    : (this: Window, ev: CustomEvent) => void,
  options?: AddEventListenerOptions | boolean,
): void {
  useEffect(() => {
    globalThis.addEventListener(type, listener as EventListenerOrEventListenerObject, options)
    return (): void =>
      globalThis.removeEventListener(type, listener as EventListenerOrEventListenerObject, options)
  }, [type, listener, options])
}
